import type { IFieldTypesKey, IFieldValue } from "../logging/DisplayLog";

import { createContext, type ReactNode, useContext, useState } from "react";

export const DisplayLogContext = createContext<{
  current: Map<string, Map<IFieldTypesKey, IFieldValue>> | null;
}>({
  current: null,
});

export const useDisplayLogContext = () => {
  return useContext(DisplayLogContext);
};

export const DisplayLogContextProvider = ({ children }: { children: ReactNode }) => {
  // Initialize with an empty Map
  const [current] = useState<Map<string, Map<IFieldTypesKey, IFieldValue>>>(() => new Map());

  return <DisplayLogContext.Provider value={{ current }}>{children}</DisplayLogContext.Provider>;
};
